<script>
    import tableUtilManager from "../../../plugins/common/util/table-util-manager";

    export default {
        name: "ComponentTableSortAndSearchHelper",
        data() {
            return {
                callbackSort: undefined,
                sortingKey: undefined,
            };
        },
        watch: {
            filteredItems() {
                this.$emit('update:filtered', this.filteredItems);
            },

            search() {
                if (this.filterKeys.length > 0 && !!(this.search || "").trim()) {
                    this.mappedItems.forEach(e => e.visible = tableUtilManager.searchByKeyword(e.raw, this.search, this.filterKeys));
                } else {
                    this.mappedItems.forEach(e => e.visible = true);
                }
            },
        },
        computed: {
            sortedAndFilteredItems() {
                let temp = this.mappedItems.slice();

                if (this.callbackSort) {
                    return temp.sort(this.callbackSort);
                } else {
                    return temp;
                }
            },

            headersFilterable() {
                return this.headersSerialized.filter(e => e.filterable);
            },

            filterKeys() {
                return this.headersFilterable.map(e => e.key);
            },
        },
        methods: {
            onSortUp(header) {
                this.callbackSort = (a, b) => {
                    const value1 = tableUtilManager.byString(a, "raw." + header.key);
                    const value2 = tableUtilManager.byString(b, "raw." + header.key);
                    return this.sortFunction(value1, value2);
                };
                // this.items.sort(this.callbackSort);
                this.sortingKey = header.key;
            },

            onSortDown(header) {
                this.callbackSort = (a, b) => {
                    const value1 = tableUtilManager.byString(a, "raw." + header.key);
                    const value2 = tableUtilManager.byString(b, "raw." + header.key);
                    return this.sortFunction(value2, value1);
                };
                // this.items.sort(this.callbackSort);
                this.sortingKey = header.key;
            },

            onSortOrigin() {
                this.sortingKey = undefined;
                this.callbackSort = undefined;
            },

            sortFunction(value1, value2) {
                if (tableUtilManager.isNOU(value1) && tableUtilManager.isNOU(value1)) return 0;
                if (tableUtilManager.isNOU(value1) && !!value2) return 1;
                if (!!value1 && tableUtilManager.isNOU(value1)) return -1;

                const type = typeof value1;

                if (type === 'string') {
                    const a = (value1 || "").trim();
                    const b = (value2 || "").trim();
                    return a.localeCompare(b);
                } else {
                    if (value1 < value2) {
                        return -1;
                    }

                    if (value1 > value2) {
                        return 1;
                    }

                    return 0;
                }
            },
        }
    }
</script>

<style scoped>

</style>